module.exports = __webpack_public_path__ + "img/sender-du-ikke-lige-1.e5b0f2d6.png";